import { theme } from '@/styles/theme';

export const styles = {
  calendarContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  icon: { marginLeft: -6 },
  iconImage: {
    fontSize: 18,
    color: theme.palette.gray.light,
  },
  fullWidth: {
    marginLeft: 0,
    width: '100%',
    '& .MuiInputBase-input': {
      cursor: 'pointer',
      textTransform: 'capitalize',
    },
    '& .MuiPickersCalendarHeader-label': {
      textTransform: 'capitalize',
    },
    '& .MuiPickersMonth-monthButton': {
      textTransform: 'capitalize',
    },
  },
  calendar: {
    backgroundColor: 'white',
    marginLeft: -1,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
      textTransform: 'capitalize',
      fontWeight: 600,
    },
    '& .MuiPickersCalendarHeader-label': {
      textTransform: 'capitalize',
    },
    '& .MuiPickersMonth-monthButton': {
      textTransform: 'capitalize',
    },
    '& .MuiButtonBase-root': {
      color: theme.palette.gray.light,
    },
  },
};
